import { render, staticRenderFns } from "./PaypalCardPay.vue?vue&type=template&id=fd9ae6aa&"
import script from "./PaypalCardPay.vue?vue&type=script&lang=js&"
export * from "./PaypalCardPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports